/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import AsideBrandHeader from './AsideBrandHeader';
import AsideMenu from './AsideMenu';

class Aside extends React.Component {
  render() {
    return (
      <div className="kt-aside  kt-aside--fixed  kt-grid__item kt-grid kt-grid--desktop kt-grid--hor-desktop" id="kt_aside">
        <AsideBrandHeader />
        <AsideMenu />
      </div>
    );
  }
}

export default Aside;



// WEBPACK FOOTER //
// ./src/js/common/components/Theme/Aside/index.jsx